// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.flex-h {
  display: flex;
  flex-direction: row;
}
.flex-v {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.nowrap {
  white-space: nowrap;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
h1 {
  font-size: 36px;
}
h3,
h1 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  margin-top: 20px;
  margin-bottom: 10px;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.pull-left {
  float: left !important;
}
.pull-right {
  float: right !important;
}
.fade {
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
a {
  color: #8784ee;
  text-decoration: none;
}
.form-themed table {
  color: var(--text-primary-color);
}
.form-themed table th,
.form-themed table td {
  font-size: 15px;
  font-weight: normal;
}
.form-themed table th {
  line-height: 60px;
}
.form-themed table td {
  line-height: 18px;
  padding: 0;
}
.form-themed .p-r-1 {
  padding-right: 1rem !important;
}
.form-themed label {
  margin-bottom: 5px;
}
.form-themed label.wrapperLabel {
  cursor: pointer;
}
.form-themed label.wrapperLabel:not(.checkboxLabel) {
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.form-themed label.wrapperLabel:not(.checkboxLabel) .wrapperText {
  display: block;
  order: -1;
}
.form-themed .btn[disabled],
.form-themed input[type=text][disabled],
.form-themed input[type=password][disabled],
.form-themed input[type=number][disabled],
.form-themed .btn.disabled,
.form-themed input[type=text].disabled,
.form-themed input[type=password].disabled,
.form-themed input[type=number].disabled,
.form-themed .btn[disabled]:hover,
.form-themed input[type=text][disabled]:hover,
.form-themed input[type=password][disabled]:hover,
.form-themed input[type=number][disabled]:hover,
.form-themed .btn.disabled:hover,
.form-themed input[type=text].disabled:hover,
.form-themed input[type=password].disabled:hover,
.form-themed input[type=number].disabled:hover,
.form-themed .btn[disabled]:active,
.form-themed input[type=text][disabled]:active,
.form-themed input[type=password][disabled]:active,
.form-themed input[type=number][disabled]:active,
.form-themed .btn.disabled:active,
.form-themed input[type=text].disabled:active,
.form-themed input[type=password].disabled:active,
.form-themed input[type=number].disabled:active {
  background-color: var(--ui-gray-darker);
  border-color: var(--ui-gray-light);
  color: var(--text-primary-color);
}
.form-themed .btn[disabled] + .wrapperText,
.form-themed input[type=text][disabled] + .wrapperText,
.form-themed input[type=password][disabled] + .wrapperText,
.form-themed input[type=number][disabled] + .wrapperText,
.form-themed .btn.disabled + .wrapperText,
.form-themed input[type=text].disabled + .wrapperText,
.form-themed input[type=password].disabled + .wrapperText,
.form-themed input[type=number].disabled + .wrapperText,
.form-themed .btn[disabled]:hover + .wrapperText,
.form-themed input[type=text][disabled]:hover + .wrapperText,
.form-themed input[type=password][disabled]:hover + .wrapperText,
.form-themed input[type=number][disabled]:hover + .wrapperText,
.form-themed .btn.disabled:hover + .wrapperText,
.form-themed input[type=text].disabled:hover + .wrapperText,
.form-themed input[type=password].disabled:hover + .wrapperText,
.form-themed input[type=number].disabled:hover + .wrapperText,
.form-themed .btn[disabled]:active + .wrapperText,
.form-themed input[type=text][disabled]:active + .wrapperText,
.form-themed input[type=password][disabled]:active + .wrapperText,
.form-themed input[type=number][disabled]:active + .wrapperText,
.form-themed .btn.disabled:active + .wrapperText,
.form-themed input[type=text].disabled:active + .wrapperText,
.form-themed input[type=password].disabled:active + .wrapperText,
.form-themed input[type=number].disabled:active + .wrapperText {
  color: var(--text-primary-color);
  cursor: auto;
}
.form-themed input[type=text],
.form-themed input[type=password],
.form-themed input[type=number] {
  background-color: var(--ui-gray);
  border-color: var(--ui-border-color);
  color: var(--text-primary-color);
  font-weight: normal;
}
.form-themed input[type=text]:active,
.form-themed input[type=password]:active,
.form-themed input[type=number]:active,
.form-themed input[type=text]:focus,
.form-themed input[type=password]:focus,
.form-themed input[type=number]:focus {
  background-color: var(--ui-gray-dark);
  border: 2px solid var(--active-color);
  box-shadow: none;
}
.form-themed input[type=text]:active + .wrapperText,
.form-themed input[type=password]:active + .wrapperText,
.form-themed input[type=number]:active + .wrapperText,
.form-themed input[type=text]:focus + .wrapperText,
.form-themed input[type=password]:focus + .wrapperText,
.form-themed input[type=number]:focus + .wrapperText {
  color: var(--active-color);
}
.form-themed .btn-primary {
  background-color: var(--active-color);
  border-collapse: var(--ui-border-color-active);
  color: var(--ui-text-color-active);
}
.form-themed .btn-primary:hover,
.form-themed .btn-primary:active,
.form-themed .btn-primary:focus,
.form-themed .btn-primary:focus:active {
  background-color: var(--ui-active-color);
  border-collapse: var(--ui-border-color-active);
  color: var(--ui-text-color-active);
}
.form-themed .form-control {
  background-color: #fff;
  border: 0;
  font-size: 14px;
  height: 30px;
  line-height: 16px;
  padding: 8px 9px 6px;
}
.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
}
.form-control:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(102,175,233,0.6);
}
.form-control::-ms-expand {
  border: 0;
  background-color: transparent;
}
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: ;
  opacity: 1;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: ;
}
input[type=range] {
  display: block;
  width: 100%;
}
.CineDialog {
  background: var(--ui-gray-darkest);
  color: var(--text-secondary-color);
  filter: drop-shadow(0 0 3px var(--ui-gray-darkest));
  border: none;
  border-radius: 8px;
  width: inherit;
}
.CineDialog h5 {
  font-size: 20px;
  line-height: 35px;
  margin: 0;
}
.CineDialog h5,
.CineDialog label {
  font-weight: 400;
}
.CineDialog .cine-navigation,
.CineDialog .cine-controls,
.CineDialog .cine-options {
  cursor: default;
}
.CineDialog .fps-section input[type="range"] {
  background-color: transparent;
  border: 0 none;
  outline: 0 none;
}
.CineDialog .fps-section input[type="range"]::-ms-tooltip {
  display: none;
}
.CineDialog .double-row-style {
  box-sizing: border-box;
  width: 290px;
  height: 70px;
  padding: 10px;
  top: 2%;
  left: 35%;
}
.CineDialog .double-row-style .cine-navigation {
  position: absolute;
  right: 16px;
  top: 10px;
}
.CineDialog .double-row-style .cine-navigation .btn {
  padding: 0 4px;
}
.CineDialog .double-row-style .cine-navigation .btn i {
  font-size: 32px;
  line-height: 32px;
}
.CineDialog .double-row-style .cine-controls {
  left: 0px;
}
.CineDialog .double-row-style .cine-options {
  padding: 0px 0;
}
.CineDialog .double-row-style .cine-options .fps-section {
  width: 175px;
  float: left;
}
.CineDialog .double-row-style .cine-options .fps {
  float: right;
}
.CineDialog .single-row-style {
  box-sizing: content-box;
  width: 425px;
  height: 45px;
  padding: 4px 8px;
  top: 2%;
  left: 35%;
}
.CineDialog .single-row-style .cine-navigation {
  float: right;
  overflow: hidden;
  padding-right: 12px;
  position: relative;
}
.CineDialog .single-row-style .cine-navigation .btn {
  padding: 0 2px;
  margin: 0 0 0 2px;
  border: 0 none;
}
.CineDialog .single-row-style .cine-navigation .btn:first-of-type {
  margin-left: 0;
}
.CineDialog .single-row-style .cine-navigation .btn i {
  font-size: 32px;
  line-height: 45px;
}
.CineDialog .single-row-style .cine-controls {
  position: relative;
  float: left;
  overflow: hidden;
}
.CineDialog .single-row-style .cine-controls .btn {
  font-size: 22px;
  line-height: 45px;
  min-width: 28px;
  padding: 0 0px;
  margin: 0 4px;
  border: 0 none;
}
.CineDialog .single-row-style .cine-options {
  display: block;
  position: relative;
  width: 150px;
  float: left;
  overflow: hidden;
  padding: 0;
  margin: 0 0 0 10px;
}
.CineDialog .single-row-style .cine-options .fps-section {
  display: block;
  float: left;
  width: 80px;
}
.CineDialog .single-row-style .cine-options .fps-section input[type="range"] {
  line-height: 45px;
  height: 45px;
}
.CineDialog .single-row-style .cine-options .fps {
  display: block;
  width: 68px;
  float: left;
  padding: 0;
  margin: 0 0 0 2px;
  text-align: center;
  line-height: 45px;
  font-size: 14px;
  line-height: 1.42857143;
}
.CineDialog .btn {
  color: var(--text-secondary-color);
  background-color: transparent;
  border: 0;
  border-radius: 4px;
  font-size: 15px;
  width: 45px;
  font-weight: normal;
  height: 37px;
  line-height: 37px;
  padding: 0 12px;
}
.CineDialog .btn:hover,
.CineDialog .btn:active,
.CineDialog .btn.active {
  color: var(--hover-color);
}
.CineDialog .btn[disabled]:hover {
  color: inherit;
}
.CineDialog .btn[disabled]:active {
  color: var(--text-secondary-color);
}
.CineDialog .btn.btn-primary,
.CineDialog .btn.btn-secondary,
.CineDialog .btn.btn-danger {
  transition: background-color 0.3s ease;
}
.CineDialog .btn.btn-primary:hover,
.CineDialog .btn.btn-secondary:hover,
.CineDialog .btn.btn-danger:hover,
.CineDialog .btn.btn-primary:active,
.CineDialog .btn.btn-secondary:active,
.CineDialog .btn.btn-danger:active,
.CineDialog .btn.btn-primary:focus,
.CineDialog .btn.btn-secondary:focus,
.CineDialog .btn.btn-danger:focus {
  opacity: 0.8;
}
.CineDialog .btn.btn-primary {
  background-color: var(--active-color);
  color: var(--primary-background-color);
}
.CineDialog .btn.btn-secondary {
  background-color: var(--text-secondary-color);
  color: var(--primary-background-color);
}
.CineDialog .btn.btn-danger {
  background-color: var(--text-destructive-color);
  color: var(--text-primary-color);
}
.CineDialog .btn.active {
  box-shadow: inset 1px 1px 2px var(--ui-gray-darkest);
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/common/global.styl","webpack://./../../ui/src/components/cineDialog/CineDialog.styl","webpack://./../../ui/src/components/common/form.styl"],"names":[],"mappings":"AAAA;EACE,8BAAoB;EACpB,2BAAiB;EACjB,sBAAY;ACCd;ADCA;EACE,WAAO;ACCT;ADCA;EACE,YAAQ;ACCV;ADCA;EACE,aAAS;EACT,mBAAgB;ACClB;ADCA;EACE,aAAS;EACT,sBAAgB;ACClB;ADCA;EACE,YAAW;ACCb;ADCA;EACE,mBAAa;ACCf;ADCA;EACE,iBAAY;ACCd;ADCA;EACE,kBAAY;ACCd;ADCA;EACE,gBAAY;ACCd;ADCA;EACE,eAAW;ACCb;ADCA;;EACE,oBAAa;EACb,gBAAa;EACb,gBAAa;EACb,gBAAY;EACZ,mBAAe;ACEjB;ADAA;;;;EACE,oBAAa;EACb,kBAAW;EACX,oBAAa;ACKf;ADHA;EACE,mBAAc;EACd,kBAAa;ACKf;ADHA;EACE,sBAAO;ACKT;ADHA;EACE,uBAAO;ACKT;ADHA;EACE,UAAS;EACT,wCAAoB;EACpB,mCAAe;EACf,gCAAY;ACKd;ADHA;EACE,UAAS;ACKX;ADHA;EACE,cAAO;EACP,qBAAiB;ACKnB;ACzEE;EACE,gCAAO;AD2EX;ACzEI;;EACE,eAAW;EACX,mBAAa;AD4EnB;AC1EI;EACE,iBAAa;AD4EnB;AC1EI;EACE,iBAAa;EACb,UAAS;AD4Ef;ACzEE;EACE,8BAAe;AD2EnB;ACzEE;EACE,kBAAe;AD2EnB;ACxEE;EACE,eAAQ;AD0EZ;ACxEE;EACE,eAAQ;EACR,aAAS;EACT,sBAAgB;AD0EpB;ACxEI;EACE,cAAS;EACT,SAAO;AD0Eb;ACrEM;;;;;;;;;;;;;;;;;;;;;;;;EACE,uCAAkB;EAClB,kCAAc;EACd,gCAAO;AD8Ff;AC5FQ;;;;;;;;;;;;;;;;;;;;;;;;EACE,gCAAO;EACP,YAAQ;ADqHlB;ACnHE;;;EACE,gCAAkB;EAClB,oCAAc;EACd,gCAAO;EACP,mBAAa;ADuHjB;ACpHI;;;;;;EACE,qCAAkB;EAClB,qCAAQ;EACR,gBAAY;AD2HlB;ACzHM;;;;;;EACE,0BAAO;ADgIf;AC9HE;EACE,qCAAkB;EAClB,8CAAiB;EACjB,kCAAO;ADgIX;AC7HI;;;;EAEE,wCAAkB;EAClB,8CAAiB;EACjB,kCAAO;ADiIb;AC/HE;EACE,sBAAkB;EAClB,SAAQ;EAER,eAAW;EACX,YAAQ;EACR,iBAAa;EACb,oBAAS;ADgIb;AC9HA;EACE,cAAS;EACT,WAAO;EACP,YAAQ;EACR,iBAAS;EACT,eAAW;EACX,uBAAa;EACb,WAAO;EACP,sBAAkB;EAClB,sBAAkB;EAClB,sBAAQ;EACR,kBAAe;EACf,6CAAY;ADgId;AC9HE;EACE,qBAAc;EACd,UAAS;EACT,oFAAoD;EACpD,4EAA4C;ADgIhD;AC9HE;EACE,SAAQ;EACR,6BAAkB;ADgItB;AC9HE;;;EAGE,kBAAkB;EAClB,UAAS;ADgIb;AC9HE;;EAEE,QAAQ;ADgIZ;AC9HA;EACE,cAAS;EACT,WAAO;ADgIT;AArPA;EACE,kCAAY;EACZ,kCAAO;EACP,mDAAQ;EACR,YAAQ;EACR,kBAAe;EACf,cAAO;AAuPT;AArPE;EACE,eAAW;EACX,iBAAa;EACb,SAAQ;AAuPZ;AArPE;;EACE,gBAAa;AAwPjB;AAtPE;;;EACE,eAAQ;AA0PZ;AAvPI;EACE,6BAAkB;EAClB,cAAQ;EACR,eAAS;AAyPf;AAvPM;EACE,aAAS;AAyPjB;AAvPE;EACE,sBAAY;EACZ,YAAO;EACP,YAAQ;EACR,aAAS;EACT,OAAK;EACL,SAAM;AAyPV;AAvPI;EACE,kBAAU;EACV,WAAO;EACP,SAAK;AAyPX;AAvPM;EACE,cAAS;AAyPjB;AAvPQ;EACE,eAAW;EACX,iBAAa;AAyPvB;AAvPI;EACE,SAAM;AAyPZ;AAvPI;EACE,cAAS;AAyPf;AAvPM;EACE,YAAO;EACP,WAAO;AAyPf;AAvPM;EACE,YAAO;AAyPf;AAtPE;EACE,uBAAY;EACZ,YAAO;EACP,YAAQ;EACR,gBAAS;EACT,OAAK;EACL,SAAM;AAwPV;AAtPI;EACE,YAAO;EACP,gBAAU;EACV,mBAAe;EACf,kBAAU;AAwPhB;AAtPM;EACE,cAAS;EACT,iBAAQ;EACR,cAAQ;AAwPhB;AAvPQ;EACE,cAAa;AAyPvB;AAvPQ;EACE,eAAW;EACX,iBAAa;AAyPvB;AAvPI;EACE,kBAAU;EACV,WAAO;EACP,gBAAU;AAyPhB;AAvPM;EACE,eAAW;EACX,iBAAa;EACb,eAAW;EACX,cAAS;EACT,aAAQ;EACR,cAAQ;AAyPhB;AAvPI;EACE,cAAS;EACT,kBAAU;EACV,YAAO;EACP,WAAO;EACP,gBAAU;EACV,UAAS;EACT,kBAAQ;AAyPd;AAvPM;EACE,cAAS;EACT,WAAO;EACP,WAAO;AAyPf;AAxPQ;EACE,iBAAa;EACb,YAAQ;AA0PlB;AAxPM;EACE,cAAS;EACT,WAAO;EACP,WAAO;EACP,UAAS;EACT,iBAAQ;EACR,kBAAY;EACZ,iBAAa;EACb,eAAW;EACX,uBAAa;AA0PrB;AAxPE;EACE,kCAAO;EACP,6BAAkB;EAClB,SAAQ;EACR,kBAAe;EACf,eAAW;EACX,WAAO;EACP,mBAAa;EACb,YAAQ;EACR,iBAAa;EACb,eAAS;AA0Pb;AAxPI;;;EACE,yBAAO;AA4Pb;AAzPM;EACE,cAAO;AA2Pf;AA1PM;EACE,kCAAO;AA4Pf;AA1PI;;;EACE,sCAAY;AA8PlB;AA5PM;;;;;;;;;EACE,YAAS;AAsQjB;AApQI;EACE,qCAAkB;EAClB,sCAAO;AAsQb;AApQI;EACE,6CAAkB;EAClB,sCAAO;AAsQb;AApQI;EACE,+CAAkB;EAClB,gCAAO;AAsQb;AApQI;EACE,oDAAY;AAsQlB","sourcesContent":["*\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n\n.full-width\n  width: 100%\n\n.full-height\n  height: 100%\n\n.flex-h\n  display: flex\n  flex-direction: row\n\n.flex-v\n  display: flex\n  flex-direction: column\n\n.flex-grow\n  flex-grow: 1\n\n.nowrap\n  white-space: nowrap\n\n.text-right\n  text-align: right;\n\n.text-center\n  text-align: center;\n\n.text-left\n  text-align: left;\n\nh1\n  font-size: 36px;\n\nh3, h1\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  margin-top: 20px;\n  margin-bottom: 10px;\n\nbutton, input, select, textarea\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n\n.row\n  margin-right: -15px;\n  margin-left: -15px;\n\n.pull-left\n  float: left!important;\n\n.pull-right\n  float: right!important;\n\n.fade\n  opacity: 0;\n  -webkit-transition: opacity .15s linear;\n  -o-transition: opacity .15s linear;\n  transition: opacity .15s linear;\n\n.fade.in\n  opacity: 1;\n\na\n  color: #8784EE;\n  text-decoration: none;\n","@import '../common/global.styl'\n@import '../common/form.styl'\n\n.CineDialog\n  background: var(--ui-gray-darkest);\n  color: var(--text-secondary-color);\n  filter: drop-shadow(0 0 3px var(--ui-gray-darkest))\n  border: none\n  border-radius: 8px\n  width: inherit;\n\n  h5\n    font-size: 20px\n    line-height: 35px\n    margin: 0\n\n  h5, label\n    font-weight: 400\n\n  .cine-navigation, .cine-controls, .cine-options\n    cursor: default\n\n  .fps-section\n    input[type=\"range\"]\n      background-color: transparent\n      border: 0 none\n      outline: 0 none\n\n      &::-ms-tooltip\n        display: none\n\n  .double-row-style\n    box-sizing: border-box\n    width: 290px\n    height: 70px\n    padding: 10px\n    top: 2%\n    left: 35%\n\n    .cine-navigation\n      position: absolute\n      right: 16px\n      top: 10px\n\n      .btn\n        padding: 0 4px\n\n        i\n          font-size: 32px\n          line-height: 32px\n\n    .cine-controls\n      left: 0px\n\n    .cine-options\n      padding: 0px 0\n\n      .fps-section\n        width: 175px\n        float: left\n\n      .fps\n        float: right\n\n\n  .single-row-style\n    box-sizing: content-box\n    width: 425px\n    height: 45px\n    padding: 4px 8px\n    top: 2%\n    left: 35%\n\n    .cine-navigation\n      float: right\n      overflow: hidden\n      padding-right: 12px\n      position: relative\n\n      .btn\n        padding: 0 2px\n        margin: 0 0 0 2px\n        border: 0 none\n        &:first-of-type\n          margin-left: 0\n\n        i\n          font-size: 32px\n          line-height: 45px\n\n    .cine-controls\n      position: relative\n      float: left\n      overflow: hidden\n\n      .btn\n        font-size: 22px\n        line-height: 45px\n        min-width: 28px\n        padding: 0 0px\n        margin: 0 4px\n        border: 0 none\n\n    .cine-options\n      display: block\n      position: relative\n      width: 150px\n      float: left\n      overflow: hidden\n      padding: 0\n      margin: 0 0 0 10px\n\n      .fps-section\n        display: block\n        float: left\n        width: 80px\n        input[type=\"range\"]\n          line-height: 45px\n          height: 45px\n\n      .fps\n        display: block\n        width: 68px\n        float: left\n        padding: 0\n        margin: 0 0 0 2px\n        text-align: center\n        line-height: 45px\n        font-size: 14px;\n        line-height: 1.42857143;\n\n  .btn\n    color: var(--text-secondary-color);\n    background-color: transparent\n    border: 0\n    border-radius: 4px\n    font-size: 15px\n    width: 45px\n    font-weight: normal\n    height: 37px\n    line-height: 37px\n    padding: 0 12px\n\n    &:hover, &:active, &.active\n      color: var(--hover-color);\n\n    &[disabled]\n      &:hover\n        color: inherit\n      &:active\n        color: var(--text-secondary-color);\n\n    &.btn-primary, &.btn-secondary, &.btn-danger\n      transition: background-color 0.3s ease\n\n      &:hover, &:active, &:focus\n        opacity: 0.8\n\n    &.btn-primary\n      background-color: var(--active-color);\n      color: var(--primary-background-color)\n\n    &.btn-secondary\n      background-color: var(--text-secondary-color);\n      color: var(--primary-background-color)\n\n    &.btn-danger\n      background-color: var(--text-destructive-color);\n      color: var(--text-primary-color);\n\n    &.active\n      box-shadow: inset 1px 1px 2px var(--ui-gray-darkest)\n",".form-themed\n\n  table\n    color: var(--text-primary-color)\n\n    th, td\n      font-size: 15px\n      font-weight: normal\n\n    th\n      line-height: 60px\n\n    td\n      line-height: 18px\n      padding: 0;\n\n  // TODO: imported this from merged-styles.css\n  .p-r-1\n    padding-right: 1rem !important;\n\n  label\n    margin-bottom: 5px\n  // end TODO\n\n  label.wrapperLabel\n    cursor: pointer\n\n  label.wrapperLabel:not(.checkboxLabel)\n    cursor: pointer\n    display: flex\n    flex-direction: column\n\n    .wrapperText\n      display: block\n      order: -1\n      transition(color 0.3s ease)\n\n  .btn, input[type=text], input[type=password], input[type=number]\n    &[disabled], &.disabled\n      &, &:hover, &:active\n        background-color: var(--ui-gray-darker)\n        border-color: var(--ui-gray-light)\n        color: var(--text-primary-color)\n\n        & + .wrapperText\n          color: var(--text-primary-color)\n          cursor: auto\n\n  input[type=text], input[type=password], input[type=number]\n    background-color: var(--ui-gray)\n    border-color: var(--ui-border-color)\n    color: var(--text-primary-color)\n    font-weight: normal\n    transition(background-color 0.3s ease\\, border-color 0.3s ease)\n\n    &:active, &:focus\n      background-color: var(--ui-gray-dark)\n      border: 2px solid var(--active-color)\n      box-shadow: none\n\n      & + .wrapperText\n        color: var(--active-color)\n\n  .btn-primary\n    background-color: var(--active-color)\n    border-collapse: var(--ui-border-color-active)\n    color: var(--ui-text-color-active)\n    transition(background-color 0.3s ease\\, border-color 0.3s ease)\n\n    &:hover, &:active, &:focus, &:focus:active\n      // TODO: 0.8  opacity\n      background-color: var(--ui-active-color)\n      border-collapse: var(--ui-border-color-active)\n      color: var(--ui-text-color-active)\n\n  .form-control\n    background-color: #FFFFFF\n    border: 0\n    border-radius(2px)\n    font-size: 14px\n    height: 30px\n    line-height: 16px\n    padding: 8px 9px 6px\n\n.form-control\n  display: block;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.075);\n\n  &:focus\n    border-color: #66afe9;\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);\n\n  &::-ms-expand\n    border: 0;\n    background-color: transparent;\n\n  &[disabled],\n  &[readonly],\n  fieldset[disabled] &\n    background-color: @input-bg-disabled;\n    opacity: 1;\n\n  &[disabled],\n  fieldset[disabled] &\n    cursor: @cursor-disabled;\n\ninput[type=range]\n  display: block;\n  width: 100%;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
